// import { format } from "date-fns";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Badge } from "../ui/badge";
import { Link } from "@tanstack/react-router";
import { Card } from "../ui/card";
import type { ArticleData } from "@/api/api";
import { FEATURE_FLAG_COVER_CARD_NEW_VISUAL } from "@/pages/Home";
import { getArticleCategoryBadgeStyle } from "@/utils/colorsArticle";

export interface ArticleCardCarouselProps {
	article: ArticleData;
}
const ArticleCardCarousel: React.FC<ArticleCardCarouselProps> = (props) => {
	const { author, title, date, kategorie, ID, image, tagi } = props.article;

	return (
		<Link to={`/articles/${ID}`}>
			<Card
				key={`CoverCardMVP--Card + ${ID}`}
				className="relative h-[215px] flex flex-col justify-between rounded-xl"
			>
				<LazyLoadImage
					alt={author}
					className="absolute z-0 w-full h-[215px] object-cover object-center rounded-xl"
					effect="blur"
					src={image}
				/>
				<div className="flex flex-col justify-between z-10 p-2 w-full h-full">
					<div className="flex justify-between">
						<div className="flex gap-1">
							{kategorie.map((category) => (
								<>
								{FEATURE_FLAG_COVER_CARD_NEW_VISUAL ? (
								<Badge
									key={`${category.name}--${ID}`}
									className="text-xs font-medium"
									style={getArticleCategoryBadgeStyle(category.name)}
								>
									{category.name}
								</Badge>
								) : (
									<Badge key={`${category.name}--${ID}`} variant="highlight">
										{category.name}
									</Badge>
								)}
								</>
							))}
						</div>
						<div className="flex gap-1">
							{FEATURE_FLAG_COVER_CARD_NEW_VISUAL ? (
								<Badge key={`coverDate` + ID} variant="semitransparent">
									{date}
									{/* {format(articleDate * 1000, "dd.MM.yyyy")} */}
								</Badge>
							) : (
								<Badge key={`coverDate` + ID} variant="info">
									{date}
									{/* {format(articleDate * 1000, "dd.MM.yyyy")} */}
								</Badge>
							)}
							{tagi && Array.isArray(tagi) && tagi.length > 0 && (
								<div className="pl-2 flex gap-2">
									{tagi.map((tag) => (
										<Badge key={`${tag.name}${ID}`} variant="articleTag">
											{tag.name.toUpperCase()}
										</Badge>
									))}
								</div>
							)}
						</div>
					</div>
					<div>
						<h1 className="inline w-3/4 text-white text-lg bg-logo py-[2px] px-[5px] leading-7 box-decoration-clone">
							{title}
						</h1>
					</div>
					<div className="flex justify-between">
						{FEATURE_FLAG_COVER_CARD_NEW_VISUAL ? (
							<Badge id={`${ID}--${author}`} variant="semitransparent">
								{author}
							</Badge>
						) : (
							<Badge id={`${ID}--${author}`}>
								{author}
							</Badge>
						)}
					</div>
				</div>
			</Card>
		</Link>
	);
};

export default ArticleCardCarousel;
